export default __webpack_public_path__ + "static/The Magic of Memory Foam-9612385c3eeca5ebb066d39ab16e6702.jpg";